import { useState } from 'react';
import { Button, Typography } from '@la/ds-ui-components';
import { Activity } from '@la/types';
import {
  ProgramPermissions,
  TeamPermissions,
  UserSummary,
} from 'redux/services/types/singleActivity';
import { isGameActivity } from '../utils/singleActivityView.utils';
import ActivityAttendance from './ActivityAttendance/ActivityAttendance';
import ActivityCheckIn from './ActivityCheckIn/ActivityCheckIn';
import ActivityMatchup from './ActivityMatchup/ActivityMatchup';
import styles from './SingleActivityViewSidePanel.module.scss';

export default function SingleActivityViewSidePanel({
  activity,
  permissions,
  userSummaries,
}: {
  activity?: Activity;
  permissions?: ProgramPermissions;
  userSummaries: UserSummary[];
}) {
  const isGame = isGameActivity(activity);

  const { viewRsvpResponses, viewRosters, teamPermissions, viewCheckIn } =
    permissions ?? {};

  const viewCheckinPermission = getEditCheckinPermission(teamPermissions);
  const [activeTab, setActiveTab] = useState('default');
  const tabPermissionsArray = [
    {
      canView: viewRsvpResponses,
      value: 'attendance',
      display: 'Attendance',
    },
    {
      canView: isGame && viewRosters,
      value: 'matchup',
      display: 'Matchup',
    },
    {
      canView: viewCheckIn && viewCheckinPermission,
      value: 'checkin',
      display: 'Check in',
    },
  ];

  return (
    <div className={styles.sidePanelContainer}>
      <div className={styles.sidePanelTabsContainer}>
        {tabPermissionsArray.map(({ value, display, canView }) => (
          <div key={value} className={styles.sidePanelTabs}>
            {canView ? (
              <Button onClick={() => setActiveTab(value)} variant="text">
                <Typography variant="ui" size="medium" weight="bold">
                  {display}
                </Typography>
              </Button>
            ) : null}
          </div>
        ))}
      </div>

      {activeTab === 'attendance' && <ActivityAttendance activity={activity} />}
      {activeTab === 'matchup' && (
        <ActivityMatchup activity={activity} userSummaries={userSummaries} />
      )}
      {activeTab === 'checkin' && <ActivityCheckIn />}
    </div>
  );
}

const getEditCheckinPermission = (teamPermissions?: TeamPermissions[]) => {
  if (teamPermissions && teamPermissions.length > 0) {
    const editCheckIn = teamPermissions.filter((obj) => obj.editCheckIn);
    return editCheckIn.length ? true : false;
  }
};
